import { extrairOrientacoes } from "../../utils";
import { IAnexo } from "../../../../../utility/IAnexo";

const TEXTO_PADRAO = "--";

const removerAcentos = (texto: string): string =>
  texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

const capitalizarPrimeiraLetra = (texto?: string | null): string => {
  if (!texto) {
    return TEXTO_PADRAO;
  }

  const conteudo = texto.trim();
  if (!conteudo) {
    return TEXTO_PADRAO;
  }

  return conteudo.charAt(0).toUpperCase() + conteudo.slice(1);
};

export function definirTituloAudiencia(demanda: any | null): string {
  const titulo = demanda?.titulo_servico;

  if (!titulo) {
    return "Outras Audiências";
  }

  const tituloNormalizado = removerAcentos(titulo);

  if (tituloNormalizado.includes("civel")) return "Audiência Cível";
  if (tituloNormalizado.includes("penal")) return "Audiência Penal";
  if (tituloNormalizado.includes("trabalhista")) return "Audiência Trabalhista";

  return "Outras Audiências";
}

export function mapearDadosCard(demanda: any | null) {
  if (!demanda) {
    return {
      comarca: TEXTO_PADRAO,
      numeroProcesso: TEXTO_PADRAO,
      modalidade: TEXTO_PADRAO,
      subtipo: TEXTO_PADRAO,
      profissionalNecessario: TEXTO_PADRAO,
    };
  }

  const comarcaValida = demanda.uf_comarca && demanda.cidade_comarca
    ? `${demanda.uf_comarca} | ${demanda.cidade_comarca}`
    : TEXTO_PADRAO;

  const numeroProcessoValido = demanda.numero_processo?.trim() || TEXTO_PADRAO;
  const modalidadeValida = capitalizarPrimeiraLetra(demanda.modalidade);
  const subtipoValido = demanda.tipo_audiencia?.trim() || TEXTO_PADRAO;
  const profissionalValido = demanda.profissional_necessario?.trim() || TEXTO_PADRAO;

  return {
    comarca: comarcaValida,
    numeroProcesso: numeroProcessoValido,
    modalidade: modalidadeValida,
    subtipo: subtipoValido,
    profissionalNecessario: profissionalValido,
  };
}

export function extrairOrientacaoAtual(orientacoes: any): any {
  if (!orientacoes) {
    return undefined;
  }

  const lista = Array.isArray(orientacoes) ? orientacoes : [orientacoes];
  const { orientacoesCompletas } = extrairOrientacoes(lista as unknown[]);

  if (orientacoesCompletas.length === 0) {
    return undefined;
  }

  const ordenadas = [...orientacoesCompletas].sort((a, b) => {
    const dataA = a.modificado ? new Date(a.modificado).getTime() : 0;
    const dataB = b.modificado ? new Date(b.modificado).getTime() : 0;

    return dataB - dataA;
  });

  return ordenadas[0];
}

export function formatarData(dataISO: string): string {
  const data = new Date(dataISO);
  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const ano = data.getFullYear();
  return `${dia}/${mes}/${ano}`;
}

export function converterArquivosOrientacaoParaAnexos(arquivos: any[]): IAnexo[] {
  return arquivos.map((arquivo: any) => ({
    id_proposta_arquivo: arquivo.id_orientacao_arquivo,
    id_orientacao_arquivo: arquivo.id_orientacao_arquivo,
    id_proposta: arquivo.id_proposta,
    caminho: arquivo.caminho || arquivo.nome,
    criado: arquivo.criado,
    modificado: arquivo.modificado,
    nome_responsavel: arquivo.nome_responsavel,
    tipo_responsavel: arquivo.tipo_responsavel,
    tamanho: arquivo.tamanho || 0
  }));
}

